import ratings from './storeRatings.json'
import type { PromptPhone } from './promptSurface'

/**
 * The rating the app prompt's variant B shows — the visitor's own store,
 * refreshed at every production build (`scripts/fetch-store-ratings.mjs`).
 * `undefined` when that store has none: the prompt then leaves the rating
 * out rather than inventing one.
 */
export interface StoreRating {
  /** "4.8" */
  readonly average: string
  /** "37" */
  readonly count: string
}

type StoredRatings = Record<'app_store' | 'google_play', StoreRating | null>

export function storeRating(
  phone: PromptPhone,
  stored: StoredRatings = ratings as StoredRatings,
): StoreRating | undefined {
  return (phone === 'ios' ? stored.app_store : stored.google_play) ?? undefined
}
